// Constantes extraites de GestionTarifsDemandesPubliques (refactoring — aucune
// modification de valeur). Réutilisables par d'autres écrans tarifs/demandes.

export const TARIF_TYPES = [
  { value: 'standard', label: 'Standard', icon: '💵', color: 'blue' },
  { value: 'btp', label: 'BTP/Construction', icon: '🏗️', color: 'amber' },
  { value: 'commerce', label: 'Commerce/Services', icon: '🏪', color: 'emerald' },
  { value: 'industrie', label: 'Industrie', icon: '🏭', color: 'slate' },
  { value: 'agriculture', label: 'Agriculture', icon: '🌾', color: 'green' },
  { value: 'multi', label: 'Multi-dispositif', icon: '🔗', color: 'purple' },
  { value: 'premium', label: 'Premium', icon: '⭐', color: 'yellow' },
  { value: 'urgent', label: 'Urgent', icon: '⚡', color: 'red' }
];

// Territoires
export const TERRITOIRES = [
  { value: 'metropole', label: 'Métropole', tva: 20, description: 'France métropolitaine' },
  { value: 'martinique', label: 'Martinique', tva: 8.5, description: 'Département d\'outre-mer' },
  { value: 'guadeloupe', label: 'Guadeloupe', tva: 8.5, description: 'Département d\'outre-mer' },
  { value: 'guyane', label: 'Guyane', tva: 0, description: 'Département d\'outre-mer' },
  { value: 'reunion', label: 'La Réunion', tva: 8.5, description: 'Département d\'outre-mer' },
  { value: 'mayotte', label: 'Mayotte', tva: 0, description: 'Département d\'outre-mer' },
  { value: 'international', label: 'International', tva: 0, description: 'Hors France' }
];

// Types d'entreprises
export const TYPES_ENTREPRISES = [
  { value: 'auto_entrepreneur', label: 'Auto-entrepreneur', description: 'Micro-entreprise' },
  { value: 'sarl', label: 'SARL', description: 'Société à responsabilité limitée' },
  { value: 'sas', label: 'SAS/SASU', description: 'Société par actions simplifiée' },
  { value: 'eurl', label: 'EURL', description: 'Entreprise unipersonnelle' },
  { value: 'sa', label: 'SA', description: 'Société anonyme' },
  { value: 'scop', label: 'SCOP/SCIC', description: 'Coopérative' },
  { value: 'association', label: 'Association', description: 'Loi 1901' },
  { value: 'autre', label: 'Autre', description: 'Autre forme juridique' }
];

// V37.27 — Activités professionnelles (multi-sélection)
export const ACTIVITES_PROFESSIONNELLES = [
  { value: 'btp', label: 'BTP / Construction', icon: '🏗️' },
  { value: 'commerce', label: 'Commerce / Distribution', icon: '🏪' },
  { value: 'industrie', label: 'Industrie / Manufacturing', icon: '🏭' },
  { value: 'agriculture', label: 'Agriculture / Élevage', icon: '🌾' },
  { value: 'services', label: 'Services / Prestations', icon: '🛠️' },
  { value: 'transport', label: 'Transport / Logistique', icon: '🚚' },
  { value: 'restauration', label: 'Restauration / Hôtellerie', icon: '🍽️' },
  { value: 'sante', label: 'Santé / Médico-social', icon: '⚕️' },
  { value: 'education', label: 'Éducation / Formation', icon: '🎓' },
  { value: 'numerique', label: 'Numérique / IT', icon: '💻' },
  { value: 'artisanat', label: 'Artisanat', icon: '🎨' },
  { value: 'tourisme', label: 'Tourisme / Loisirs', icon: '🏝️' },
  { value: 'energie', label: 'Énergie / Environnement', icon: '⚡' },
  { value: 'immobilier', label: 'Immobilier', icon: '🏢' },
  { value: 'finance', label: 'Finance / Assurance', icon: '💰' },
  { value: 'autre', label: 'Autre', icon: '📋' },
];

export const MOTIF_LABELS = {
  hors_zone: 'Hors zone géographique',
  trop_eloigne: 'Distance trop importante',
  indisponibilite: 'Indisponibilité',
  conflit_calendrier: 'Conflit calendrier',
  profil_inadapte: 'Profil inadapté',
  client_injoignable: 'Client injoignable',
  autre: 'Autre',
};
